<template>
  <div class="w-full chart-container" :style="{ 'min-height': minHeigth }">
    <canvas :id="id" :aria-label="infoResumenTexto" tabindex="0"></canvas>
  </div>
</template>

<script>
import { i18n } from '@/i18n'
import Chart from 'chart.js'

export default {
  name: 'Chart',
  props: {
    type: {
      type: String,
      default: 'bar'
    },
    id: {
      type: String,
      default: 'chart'
    },
    labelUsed: {
      type: String,
      default: ''
    },
    labelTotal: {
      type: String,
      default: ''
    },
    chardataFullstack: {
      type: [Array, Object]
    },
    colorWarning: {
      type: String,
      default: '#ff8896'
    },
    // colorImportant: {
    //   type: String,
    //   default: '#007FFF'
    // },
    limitWarning: {
      type: Number,
      default: 60
    },
    limitImportant: {
      type: Number,
      default: 80
    }
  },
  data () {
    return {
      ChartData: null,
      myChart: null,
      colorPrimary: this.getColor('--primary-300'),
      colorSecondary: '#ffffff',
      colorImportant: this.getColor('--primary-DEFAULT'),
      colorSecondaryDark: this.getColor('--darkblue-DEFAULT'),
      colorFont: this.getColor('--secondary-DEFAULT'),
      colorFontDark: this.getColor('--secondary-100'),
      colorGridLinesDark: this.getColor('--darkblue-400'),
      colorBorder: this.getColor('--primary-600'),
    }
  },
  computed: {
    minHeigth () {
      let heigth = 150
      if (this.chardataFullstack) {
        const actualHeightAux = (this.chardataFullstack.length + 1) * 28
        if (actualHeightAux > heigth) {
          heigth = actualHeightAux
        }
      }
      return heigth + 'px'
    },
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    finalLabelUsed: function () {
      return this.labelUsed || i18n.t('app.used')
    },
    finalLabelTotal: function () {
      return this.labelTotal || i18n.t('app.total')
    },
    infoResumenTexto () {
      var msg = ''
      if (this.chardataFullstack) {
        msg += this.$t('license.header') + '. '
        this.chardataFullstack.forEach(x => {
          msg += '' + x.nombre + ': ' + x.numUtilizado + ' ' + this.$t('app.of') + ' ' + x.numTotal + '; '
        })
      }
      return msg
    },
    infoResumenTextoFormat () {
      var msg = ''
      if (this.chardataFullstack) {
        msg += `<b>${this.$t('license.header')}</b><br/>`
        this.chardataFullstack.forEach(x => {
          msg += '' + x.nombre + ': ' + x.numUtilizado + ' ' + this.$t('app.of') + ' ' + x.numTotal + '<br/>'
        })
      }
      return msg
    }
  },
  watch: {
    chardataFullstack: 'dataChangeHandler',
    darkMode: 'changeDarkmode',
  },
  methods: {
    getColor (property) {
      return getComputedStyle(document.querySelector(':root')).getPropertyValue(property)
    },
    changeDarkmode: function () {
      Chart.defaults.global.defaultFontColor = this.darkMode ? this.colorFontDark : this.colorFont
      this.myChart.config.options.scales.xAxes.forEach(x => {
        x.gridLines.color = this.darkMode ? this.colorGridLinesDark : this.colorPrimary
      }) 
      this.myChart.config.options.scales.yAxes.forEach(x => {
        x.gridLines.color = this.darkMode ? this.colorGridLinesDark : this.colorPrimary
        x.gridLines.zeroLineColor = this.darkMode ? this.colorGridLinesDark : this.colorPrimary
      }) 
      this.myChart.config.data.datasets[0].backgroundColor = this.colorPrimary
      this.myChart.config.data.datasets[1].backgroundColor = this.darkMode ? this.colorSecondaryDark : this.colorSecondary
      this.myChart.config.options.legend.labels.fontColor = this.darkMode ? this.colorFontDark : this.colorFont
      this.updateFixChart()
    },
    updateFixChart () {
      this.controlColor()
      this.myChart.update()
      setTimeout(() => {
        this.myChart.update()
        this.$emit('chartUpdated', this.infoResumenTextoFormat)
      }, 200)
    },
    controlColor () {
      const colors = []
      this.myChart.config.data.datasets[0].data.forEach(x => {
        if (x >= this.limitImportant) colors.push(this.colorImportant)
        else colors.push(this.colorPrimary)
      })
      this.myChart.config.data.datasets[0].backgroundColor = colors
    },
    removeData () {
      this.myChart.data.labels = []
      // this.myChart.data.datasets.forEach(x => x.data=[])
      for (let index = 0; index < this.myChart.data.datasets.length; index++) {
        this.myChart.data.datasets[index].data = []
      }
      // this.myChart.data.labels.pop()
      // this.myChart.data.datasets.forEach(x => x.data.pop())
      this.updateFixChart()
    },
    addData (label, data) {
      this.myChart.data.labels.push(label)
      this.myChart.data.datasets.forEach(x => x.data.push(data))
      this.updateFixChart()
    },
    dataChangeHandler: function () {
      if (this.myChart !== null && this.myChart !== undefined) {
        this.removeData()
      } 
      Chart.defaults.global.defaultFontColor = this.darkMode ? this.colorFontDark : this.colorFont
      const ctx = document.getElementById(this.id)
      const labels = []
      const values = []
      const valuesTotal = []
      this.chardataFullstack.forEach(element => {
        labels.push(element.nombre)
        values.push(element.porcentajeEnUso)
        valuesTotal.push(element.porcentajeRestante)
      })
      this.ChartData = null
      const self = this
      this.ChartData = {
        type: this.type, // 'horizontalBar',
        data: {
          labels: labels,
          datasets: [
            {
              id: 1,
              label: this.finalLabelUsed,
              data: values,
              backgroundColor: this.colorPrimary,
              borderColor: this.colorBorder,
              borderWidth: 2,
              maxBarThickness: 40,
              fontSize: 40,
            },
            {
              id: 2,
              label: this.finalLabelTotal,
              data: valuesTotal,
              backgroundColor: this.darkMode ? this.colorSecondaryDark : this.colorSecondary,
              borderColor: this.colorBorder,
              borderWidth: 2,
              maxBarThickness: 40,
              fontSize: 40,
            }
          ]
        },
        options: {
          legend: {
            display: false,
            labels: {
              fontColor: this.darkMode ? this.colorFontDark : this.colorFont,
              fontSize: 14,
              backgroundColor: this.colorPrimary,
            }
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                const item = data.datasets[tooltipItem.datasetIndex]
                var label = item.label || ''
                if (label) {
                  if (item.id === 1) {
                    // label += ': ' + self.chardataFullstack[tooltipItem.index].numUtilizado + ''
                    label = `${label}: ${i18n.n(self.chardataFullstack[tooltipItem.index].numUtilizado, 'integer')}`
                  } else {
                    // label += ': ' + self.chardataFullstack[tooltipItem.index].numTotal + ''
                    label = `${label}: ${i18n.n(self.chardataFullstack[tooltipItem.index].numTotal, 'integer')}`
                  }
                }
                // label += Math.round(tooltipItem.yLabel * 100) / 100
                return label
              },
              title: function (tooltipItems, data) {
                return data.labels[tooltipItems[0].index]
              }
            }
          },
          maintainAspectRatio: false,
          scales: {
            xAxes: [{
              stacked: true,
              gridLines: {
                color: this.darkMode ? this.colorGridLinesDark : this.colorSecondary,
              },
              ticks: {
                precision: 0,
                fontSize: 14,
                callback: function (value, index, values) {
                  if (index === 0) return '%'
                  return i18n.n(value, 'integer')
                }
              }
            }],
            yAxes: [{
              stacked: true,
              gridLines: {
                color: this.darkMode ? this.colorGridLinesDark : this.colorSecondary,
                zeroLineColor: this.darkMode ? this.colorGridLinesDark : this.colorSecondary
              },
              ticks: {
                beginAtZero: true,
                fontSize: 14,
                callback: function (value, index, values) {
                  return value.length > 12 ? value.substr(0, 12) + '..' : value
                }
              }
            }]
          },
          onHover: (event, chartElement) => {
            const target = event.native ? event.native.target : event.target
            target.style.cursor = chartElement[0] ? 'pointer' : 'default'
          }
        }
      }
      // eslint-disable-next-line no-new
      const myChart = new Chart(ctx, this.ChartData)
      this.myChart = myChart
      ctx.onclick = function (evt) {
        const activePoint = myChart.getElementAtEvent(evt)[0]
        if (activePoint && activePoint._chart) {
          const data = activePoint._chart.data
          const datasetIndex = activePoint._datasetIndex
          const label = data.labels[activePoint._index]
          const value = data.datasets[datasetIndex].data[activePoint._index]
          self.$emit('callback', label, value)
        }
      }
      this.changeDarkmode()
    }
  }
}
</script>

<style scoped>

.chart-container {
  position: relative;
  height: 22vh;
  /* height: 100%; */
}
</style>
